import { setFilter } from "QuotePage/Actions";
import { getCarriersInRegion, getFilterConfig } from "QuotePage/Selectors";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { getPlans } from "Common/PlanLoader/Selectors";

import PlansFilterPanelDumb from "./plansFilterPanel/PlansFilterPanelDumb";

import type { Dispatch } from "redux";

function mapStateToProps(state) {
  const allPlans = getPlans(state);
  const overflowPlans = allPlans.filter((plan) => plan.overflow_plan === true).length > 0;
  return {
    allPlans,
    filterConfig: getFilterConfig(state),
    companyProfile: state.companyProfile,
    carriersInRegion: getCarriersInRegion(state),
    filters: {
      deductible: true,
      network: true,
      carrier: true,
      doctorVisit: true,
      specialistVisit: true,
      overflowPlans,
      prescriptionFilters: {
        genericDrugCopays: true,
        brandDrugCopays: true,
        drugsSubjectToDeductible: true,
      },

      otherFilters: {
        outOfState: true,
        hsaEligible: true,
        maxPlanCost: true,
      },
    },
  };
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onChangeFilter: (field, rawValue) => {
      const filterValues = rawValue[Object.keys(rawValue)[0]];
      if (filterValues) {
        AnalyticsTracking.trackEvent("quote_page_filter", {
          filter_category: field,
          [field]: JSON.stringify(filterValues),
        });
      }
      dispatch(setFilter(field, rawValue));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlansFilterPanelDumb);
